import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelatedBlogsComponent } from './related-blogs.component';
import { LayoutModule } from 'src/app/layout/layout.module';

@NgModule({
  declarations: [RelatedBlogsComponent],
  imports: [CommonModule, LayoutModule],
  exports: [RelatedBlogsComponent]
})
export class RelatedBlogsModule {}
